import {
  DASHBOARD_WIDGET_DETAILS,
  DashboardWidgetType,
  DashboardWidgetUnion,
} from '@akin-home/dashboards';

import { Button } from '@akin-home/buttons/native';
import { spacing } from '@akin-home/theme';
import React, { useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import FullScreenLoader from '../../components/FullScreenLoader';
import { useStateStore } from '../../stores/useStateStore';
import { color, palette } from '../../theme';
import { DashboardProfilePanel } from '../DashboardProfilePanel';
import { DashboardTileContent } from '../DashboardTileContent/DashboardTileContent';
import { DashboardScreenViewProps } from './types';

export const PortraitDashboardScreenView = (
  props: DashboardScreenViewProps
) => {
  const { dashboard } = props;

  const { width, height } = useStateStore((state) => state.dashboard_layout);

  const dashboardTiles = (dashboard?.layout ?? []).filter(
    (elem) =>
      elem.type !== DashboardWidgetType.PROFILE &&
      !(
        elem.type === DashboardWidgetType.CONTACTS &&
        Math.min(width, height) < 600
      )
  );

  const [selectedTileIdx, setSelectedTileIdx] = useState<number>(0);
  const selectedTile = dashboardTiles?.[selectedTileIdx];

  return (
    <>
      <View style={[styles.tileContainer, styles.profilePanelContainer]}>
        <DashboardProfilePanel />
      </View>

      {dashboardTiles.length > 0 ? (
        <View style={styles.tileSelectorContainer}>
          <ScrollView
            style={styles.scrollView}
            contentContainerStyle={styles.scrollViewContent}
            horizontal
          >
            {dashboardTiles.map((tile, idx) => (
              <DashboardSelectorTile
                key={`${tile.id}_${idx}`}
                tile={tile}
                isSelected={selectedTileIdx === idx}
                onSelect={() => setSelectedTileIdx(idx)}
              />
            ))}
          </ScrollView>
        </View>
      ) : null}

      {height && selectedTile ? (
        <View
          style={[
            styles.tileContainer,
            styles.dataTileContainer,
            {
              maxHeight: HEIGHT_RESTRICTED_WIDGETS.includes(selectedTile.type)
                ? width * 1.2
                : undefined,
            },
          ]}
        >
          <DashboardTileContent
            widget={selectedTile}
            width={width}
            height={height}
          />
        </View>
      ) : (
        <FullScreenLoader />
      )}
    </>
  );
};

const DashboardSelectorTile = (props: {
  tile: DashboardWidgetUnion;
  isSelected?: boolean;
  onSelect?: () => any;
}) => {
  const { tile, isSelected = false, onSelect } = props;

  const widgetDetails = DASHBOARD_WIDGET_DETAILS.find(
    (elem) => elem.type === tile.type
  );
  const {
    title = tile.type,
    icon,
    icon_color = color.text,
  } = widgetDetails ?? {};

  return (
    <Button
      size="small"
      variant="secondary"
      icon={icon}
      textStyle={{ color: isSelected ? palette.primary_70 : color.text }}
      style={{
        backgroundColor: isSelected ? palette.Pale_blue : palette.lightGrey1,
      }}
      iconColor={icon_color}
      onPress={onSelect}
    >
      {title}
    </Button>
  );
};

const styles = StyleSheet.create({
  tileContainer: {
    padding: spacing[2],
  },
  profilePanelContainer: {
    minHeight: 60,
  },
  dataTileContainer: {
    flex: 1,
  },
  tileSelectorContainer: {
    width: '100%',
    padding: spacing[2],
    justifyContent: 'center',
  },
  scrollView: {
    width: '100%',
    elevation: 3,
    backgroundColor: 'white',
    borderRadius: 10,
  },
  scrollViewContent: {
    gap: spacing[2],
    padding: spacing[2],
  },
});

const HEIGHT_RESTRICTED_WIDGETS = [
  DashboardWidgetType.WEATHER,
  DashboardWidgetType.MEALS,
  DashboardWidgetType.GOAL_CAROUSEL,
];
